import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { flattenData } from "../../../../Utilitie";
import * as echarts from "echarts";

const MonthWisePWITOHOGraph = ({
  selectedMonths,
  selectedSections,
  sortedPrev,
  sortedCurr,
  selectedFy,
}) => {
  const getSectionData = (monthData, section) =>
    monthData?.data?.find((d) => d.section === section) || {};

  useEffect(() => {
    if (selectedMonths.length === 0 || selectedSections.length === 0) return;

    const chartDom = document.getElementById("pwiChart");
    let myChart = echarts.init(chartDom);

    const prevTotalTO = selectedMonths.map((month) => {
      const m = sortedPrev.find((o) => o.month.slice(0, 3) === month);
      return selectedSections.reduce((acc, s) => {
        const d = getSectionData(m, s);
        return acc + Number(d.to_value || 0);
      }, 0);
    });
    const currTotalTO = selectedMonths.map((month) => {
      const m = sortedCurr.find((o) => o.month.slice(0, 3) === month);
      return selectedSections.reduce((acc, s) => {
        const d = getSectionData(m, s);
        return acc + Number(d.to_value || 0);
      }, 0);
    });

    const option = {
      title: {
        text: `T/O – Prev (${selectedFy.replace(
          /\d+/g,
          (y) => +y - 1
        )}) vs Curr Year (${selectedFy})`,
        left: "center",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        top: 30,
        data: [
          `T/O (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          `T/O (${selectedFy})`,
        ],
      },
      xAxis: {
        type: "category",
        data: selectedMonths,
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name: `T/O (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          type: "bar",
          data: prevTotalTO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
        {
          name: `T/O (${selectedFy})`,
          type: "bar",
          smooth: true,
          data: currTotalTO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
      ],
    };
    myChart.setOption(option);

    const handleResize = () => {
      myChart.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      myChart.dispose();
    };
  }, [selectedMonths, selectedSections, sortedPrev, sortedCurr]);

  return (
    <div>
      <div className="papaDiv">
        <div
          id="pwiChart"
          style={{ width: "100%", height: "50vh", marginTop: "30px" }}
        ></div>
      </div>
    </div>
  );
};

export default MonthWisePWITOHOGraph;
